// Comparação de versões do app no formato "3.0.0-beta.3" (semver simples): o
// núcleo numérico manda e um pré-lançamento (beta) vale MENOS que a versão
// final igual — 3.0.0-beta.2 < 3.0.0-beta.3 < 3.0.0. A conta antiga
// (split(".").map(Number)) virava NaN em "0-beta" e nunca via um beta mais novo.

function analisar(v) {
  const texto = String(v || "").trim().replace(/^v/i, "");
  const i = texto.indexOf("-");
  const nucleo = (i < 0 ? texto : texto.slice(0, i)).split(".").map(n => parseInt(n, 10) || 0);
  while (nucleo.length < 3) nucleo.push(0);
  const pre = i < 0 ? [] : texto.slice(i + 1).split(".");
  return { nucleo, pre };
}

// -1 (a < b), 0 (iguais) ou 1 (a > b)
export function compararVersoes(a, b) {
  const A = analisar(a), B = analisar(b);
  for (let i = 0; i < Math.max(A.nucleo.length, B.nucleo.length); i++) {
    const d = (A.nucleo[i] || 0) - (B.nucleo[i] || 0);
    if (d) return d > 0 ? 1 : -1;
  }
  if (!A.pre.length && !B.pre.length) return 0;
  if (!A.pre.length) return 1;  // versão final > pré-lançamento
  if (!B.pre.length) return -1;
  for (let i = 0; i < Math.max(A.pre.length, B.pre.length); i++) {
    const x = A.pre[i], y = B.pre[i];
    if (x === undefined) return -1;
    if (y === undefined) return 1;
    const nx = /^\d+$/.test(x), ny = /^\d+$/.test(y);
    if (nx && ny) {
      const d = Number(x) - Number(y);
      if (d) return d > 0 ? 1 : -1;
    } else if (nx !== ny) {
      return nx ? -1 : 1;  // número < texto, como no semver
    } else if (x !== y) {
      return x > y ? 1 : -1;
    }
  }
  return 0;
}

// true só quando há versão remota e ela é mais nova que a instalada.
export const versaoMaisNova = (remota, atual) => !!remota && compararVersoes(remota, atual) > 0;
